<template>
 <div
   class="bg-white relative inline-flex items-center justify-between cursor-pointer py-[7px] px-[10px] rounded-7 text-[10px] -tracking-[0.2px] font-semibold"
 >
  <select
    v-model="selected"
    :class="modelValue ? '!text-gray-05' : '!text-gray-04'"
    class="leading-[10px] outline-none w-full bg-transparent relative z-10"
    @change="$emit('update:model-value', selected)"
  >
   <option
     v-for="opt in options"
     :value="opt"
     :key="opt"
   >{{ opt }}</option>
  </select>
  <span
    :class="{ 'border-l border-l-gray-04': useSeparate }"
    class="pl-[10px] ml-[10px] absolute right-[10px] z-[1]"
  >
   <img
     :src="select"
     alt="arrow"
   />
  </span>
 </div>
</template>

<script setup>
import { ref } from 'vue';
import select from '@/assets/select.svg'

const props = defineProps({
 placeholder: {
  type: String,
  default: '',
 },

 options: {
  type: Array,
  default: () => ([]),
 },

 modelValue: {
  type: [String, Number],
  default: '',
 },

 useSeparate: {
  type: Boolean,
  default: true,
 }
})

const selected = ref(props.modelValue || props.placeholder)
</script>

<style lang="scss" scoped></style>